document.addEventListener('DOMContentLoaded', function () {
  const productForm = document.querySelector('form[action="/cart/add"]');
  if (!productForm) return;

  const variantInput = productForm.querySelector('input[name="id"]');
  const buyBtn = document.querySelector('.buy-it-now-btn');
  
  // Sticky button uses its own hidden input
  const stickyVariantInput = document.getElementById('sticky__selected_variant_id');
  const stickyBuyBtn = document.querySelector('.sticky-buy-it-now-btn');

  // --- Main button setup ---
  if (variantInput && buyBtn) {
    buyBtn.dataset.variantId = variantInput.value;

    const observer = new MutationObserver(function () {
      buyBtn.dataset.variantId = variantInput.value;
    });
    observer.observe(variantInput, { attributes: true, attributeFilter: ['value'] });
    variantInput.addEventListener('change', function () {
      buyBtn.dataset.variantId = this.value;
    });
  }
  // --- Sticky button setup ---
  if (stickyVariantInput && stickyBuyBtn) {
    stickyBuyBtn.dataset.variantId = stickyVariantInput.value;

    const stickyObserver = new MutationObserver(function () {
      stickyBuyBtn.dataset.variantId = stickyVariantInput.value;
    });
    stickyObserver.observe(stickyVariantInput, { attributes: true, attributeFilter: ['value'] });
    stickyVariantInput.addEventListener('change', function () {
      stickyBuyBtn.dataset.variantId = this.value;
    });
  }

  // --- Shared click handler for both buttons ---
  document.querySelectorAll('.buy-it-now-btn, .sticky-buy-it-now-btn').forEach(function (btn) {
    btn.addEventListener('click', function () {
      const variantId = this.dataset.variantId;
      if (!variantId) return;

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: variantId, quantity: 1 })
      })
      .then(() => {
        window.location.href = '/checkout';
      })
      .catch(err => console.error('Add to cart failed:', err));
    });
  });
});